/**
 * 系统管理-卡片页
 */
import React from 'react';
import PropTypes from 'prop-types';
import { getLocalStorage } from '@/assets/js/storage';

class Card extends React.Component {

    componentDidMount() {
        const userInfo = getLocalStorage('auth') ? JSON.parse(getLocalStorage('auth')).userInfo : null;
        const { accountType } = userInfo;

        if (accountType == 'COMPANY') {
            this.props.history.replace({ pathname: '/home/system/baseinfo' });
        } else {
            this.props.history.replace({ pathname: '/home/system/parameter' });
        }
    }

    render() {
        return (
            <div></div>
        );
    }
}

Card.propTypes = {
    history: PropTypes.object, // 路由
};

export default Card;